// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"8893b7e4","417":"95294c16","753":"a15f9840","842":"cfdaa6c1","912":"9986ac17","933":"e1b65559"}[chunkId] + ".chunk.js";
};